"use client";

import { useFormStatus } from "react-dom";
import { Button } from "@/components/ui/button";

type SubmitButtonProps = {
  children: React.ReactNode;
  pendingText?: string;
  className?: string;
  variant?: "default" | "yellow";
  disabled?: boolean;
};

export function SubmitButton({
  children,
  pendingText,
  className,
  variant = "default",
  disabled = false,
}: SubmitButtonProps) {
  const { pending } = useFormStatus();

  const baseClasses =
    "w-full h-14 text-lg font-light tracking-wide transition-colors duration-300";
  const variantClasses = {
    default: "bg-black hover:bg-gray-800 disabled:bg-gray-400 text-white",
    yellow: "bg-brand-yellow hover:bg-gray-200 disabled:bg-gray-400 text-black",
  };

  return (
    <Button
      type="submit"
      disabled={pending || disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${className || ""}`}
    >
      {pending ? pendingText || "Loading..." : children}
    </Button>
  );
}
